import { createSlice } from "@reduxjs/toolkit";
import { getTranslations } from './thunk';
export const initialState = {
  translation: {},
  loading: false,
  error: {}
};

export var translation = {};

const Profile = createSlice({
  name: 'Translation',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getTranslations.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(getTranslations.fulfilled, (state, action) => {
      translation = action.payload;
      state.translation = action.payload;
      state.loading = false;
    });

    builder.addCase(getTranslations.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
    
  }
});

export default Profile.reducer;